import type { Issue } from '../types/issue';
import type { Filters } from '../store/filters';

// Filter-Logik: Search ist case-insensitive substring über Key + Summary +
// Assignee + Team. Die anderen Filter sind exakter Match (sofern gesetzt).
export function applyFilters(rows: Issue[], f: Filters): Issue[] {
  const q = f.search.trim().toLowerCase();
  return rows.filter(r => {
    if (f.team     && r['Team Name']  !== f.team)     return false;
    if (f.assignee && r['Assignee']   !== f.assignee) return false;
    if (f.status   && r['Status']     !== f.status)   return false;
    if (f.priority && r['Priority']   !== f.priority) return false;
    if (q) {
      const hay = [
        r['Issue key'], r['Summary'], r['Assignee'], r['Team Name'],
      ].filter(Boolean).join(' ').toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}

// Häufigkeiten je Spalte – nützlich für Quick-Buttons und Sortierung
// der Dropdowns (häufigste zuerst).
export function countBy(rows: Issue[], key: keyof Issue): Map<string, number> {
  const map = new Map<string, number>();
  for (const r of rows) {
    const v = r[key];
    if (typeof v !== 'string' || !v) continue;
    map.set(v, (map.get(v) ?? 0) + 1);
  }
  return map;
}

export function sortedByCount(map: Map<string, number>): [string, number][] {
  return Array.from(map.entries()).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
}
